

































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { getMsTime } from "@/services/dateTime/pars-date-in-minutes";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";
import { IExcursion } from "@/@types/excursions/excursions";

import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({ components: { BSwitch } })
export default class ExcursionCard extends Vue {
  @Prop({ type: Object, default: null }) card!: IExcursion;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;

  @Inject({ from: "excursionFolder", default: null }) readonly folder!: string;
  @Inject({ from: "excursionBgFolder", default: null }) readonly bg!: string;

  mapShow = false;

  get category(): ICategory | null {
    const cat = this.categorys.find((c) => c._id == this.card.category);
    return cat ? cat : null;
  }

  getMsTime(ms: number): {
    days: number;
    hours: number;
    minutes: number;
  } {
    return getMsTime(ms);
  }
}
